import secureLog from "../../util/secureLogger";

export class FacebookPixelHandler {
  constructor() {
    this.handlerName = 'FacebookPixelHandler';
    this.pixelId = process.env.REACT_APP_FACEBOOK_PIXEL_ID || process.env.REACT_APP_FB_PIXEL_ID;

    
    if (!this.pixelId) {
      secureLog.warn('No Facebook Pixel ID provided');
      return;
    } else {
      this._loadPixelScript(this.pixelId);
    }
  }

  _loadPixelScript(pixelId) { // Fix: Accept pixelId parameter
    if (!window.fbq) {
      (function (f, b, e, v, n, t, s) {
        if (f.fbq) return;
        n = f.fbq = function () {
          n.callMethod ?
            n.callMethod.apply(n, arguments) :
            n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = true;
        n.version = '2.0';
        n.queue = [];
        t = b.createElement(e);
        t.async = true;
        t.src = 'https://connect.facebook.net/en_US/fbevents.js';
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
      })(window, document, 'script');
    }
    window.fbq('init', pixelId);
    console.log('[FacebookPixelHandler] Initialized with ID:', pixelId);
  }
}